import React, { useState, useEffect } from 'react';
import BlackButton from '../Utils/BlackButton';
import GrayButton from '../Utils/GrayButton';

//const IP = "http://143.110.239.79:5010/"
const IP = "https://pepetoys-backend.mindnt.com.mx/api/"
//const IP = "http://localhost:5010/"

const ModalEditProduct = ({ isOpen, onClose, onSave, productId }) => {
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    description: '',
    img_item: '',
    available_item: true,
    apply_promotions: false,
    atributo_1: '',
    atributo_2: '',
    product_counter_init: '',
    product_counter: ''
  });

  // Estado SEPARADO para categorías — evita cualquier race condition con formData
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);

  // Estado para imágenes múltiples
  const [imageUrls, setImageUrls] = useState([]);
  const [newImageUrl, setNewImageUrl] = useState('');

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Cargar todo cuando se abre el modal
  useEffect(() => {
    if (isOpen && productId) {
      initModal();
    }
  }, [isOpen, productId]);

  const initModal = async () => {
    setLoading(true);
    setSelectedCategoryIds([]);
    setImageUrls([]);
    setNewImageUrl('');

    try {
      // Solo dos llamadas — category_ids ya viene dentro de get-item-data
      const [itemRes, catListRes] = await Promise.all([
        fetch(`${IP}items/get-item-data?item_id=${productId}`),
        fetch(`${IP}items/categories`)
      ]);

      const [itemResult, catListResult] = await Promise.all([
        itemRes.json(),
        catListRes.json()
      ]);

      // 1. Catálogo completo de categorías
      const cats = catListResult.status === 'success' && Array.isArray(catListResult.data)
        ? catListResult.data
        : [];
      setAllCategories(cats);

      // 3. Datos del producto — category_ids ya viene en el response de get-item-data
      if (itemResult.status === 'success') {
        const data = itemResult.data;

        // data.category_ids es un array de ints: [20, 21]
        const assignedIds = Array.isArray(data.category_ids)
          ? data.category_ids.map(id => parseInt(id, 10)).filter(id => Number.isFinite(id))
          : [];
        setSelectedCategoryIds(assignedIds);

        // data.images es un array de URLs strings
        const loadedImages = Array.isArray(data.images)
          ? data.images.filter(u => u && typeof u === 'string' && u.trim())
          : [];
        setImageUrls(loadedImages);

        setFormData({
          name: data.name || '',
          price: data.price?.toString() || '',
          description: data.description || '',
          img_item: data.img_item || '',
          available_item: Boolean(data.available_item),
          apply_promotions: data.apply_promotions === 1 || data.apply_promotions === true,
          atributo_1: data.atributo_1 || '',
          atributo_2: data.atributo_2 || '',
          product_counter_init: data.product_counter_init?.toString() || '',
          product_counter: data.product_counter?.toString() || ''
        });
      }
    } catch (error) {
      console.error('Error initializing edit modal:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleCategory = (catId) => {
    const id = parseInt(catId, 10);
    setSelectedCategoryIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
    if (errors.categories) setErrors(prev => ({ ...prev, categories: '' }));
  };

  const addImageUrl = () => {
    const url = newImageUrl.trim();
    if (!url) return;
    if (imageUrls.includes(url)) {
      setErrors(prev => ({ ...prev, duplicateImage: 'Esta imagen ya fue agregada' }));
      return;
    }
    setImageUrls(prev => [...prev, url]);
    setNewImageUrl('');
    setErrors(prev => ({ ...prev, duplicateImage: '' }));
  };

  const removeImageUrl = (index) => {
    setImageUrls(prev => prev.filter((_, i) => i !== index));
  };

  const handleImageUrlKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addImageUrl();
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'El nombre es requerido';
    if (!formData.price || Number(formData.price) <= 0) newErrors.price = 'El precio debe ser mayor a 0';
    if (selectedCategoryIds.length === 0) newErrors.categories = 'Selecciona al menos una categoría';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updatedProduct = {
      id: productId,
      name: formData.name.trim(),
      price: parseFloat(formData.price),
      description: formData.description.trim() || null,
      img_item: imageUrls.length > 0 ? imageUrls[0] : (formData.img_item.trim() || null),
      category_ids: selectedCategoryIds,
      images: imageUrls,
      available_item: formData.available_item,
      apply_promotions: formData.apply_promotions ? 1 : 0,
      atributo_1: formData.atributo_1.trim() || null,
      atributo_2: formData.atributo_2.trim() || null,
      product_counter_init: formData.product_counter_init ? parseInt(formData.product_counter_init) : null,
      product_counter: formData.product_counter ? parseInt(formData.product_counter) : null
    };

    onSave(updatedProduct);
    setErrors({});
  };

  const handleClose = () => {
    setErrors({});
    setSelectedCategoryIds([]);
    setImageUrls([]);
    setNewImageUrl('');
    setFormData({
      name: '',
      price: '',
      description: '',
      img_item: '',
      available_item: true,
      apply_promotions: false,
      atributo_1: '',
      atributo_2: '',
      product_counter_init: '',
      product_counter: ''
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-900">Editar Producto</h2>
            <button onClick={handleClose} className="text-gray-400 hover:text-gray-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {loading ? (
            <div className="flex justify-center items-center py-8">
              <div className="text-gray-500">Cargando datos del producto...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">

              {/* Nombre */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                  placeholder="Nombre del producto"
                />
                {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
              </div>

              {/* Precio */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Precio *</label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  step="0.01"
                  min="0"
                  className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 ${errors.price ? 'border-red-500' : 'border-gray-300'}`}
                  placeholder="0.00"
                />
                {errors.price && <p className="text-red-500 text-xs mt-1">{errors.price}</p>}
              </div>

              {/* ── Selector de categorías tipo pills ── */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Categorías *
                  <span className="ml-1 text-gray-400 font-normal text-xs">
                    ({selectedCategoryIds.length} seleccionada{selectedCategoryIds.length !== 1 ? 's' : ''})
                  </span>
                </label>

                {allCategories.length === 0 ? (
                  <p className="text-sm text-gray-400">No hay categorías disponibles</p>
                ) : (
                  <div className="flex flex-wrap gap-2">
                    {allCategories.map(cat => {
                      const isSelected = selectedCategoryIds.includes(parseInt(cat.id, 10));
                      return (
                        <button
                          key={cat.id}
                          type="button"
                          onClick={() => toggleCategory(cat.id)}
                          className={`
                            px-3 py-1.5 rounded-full text-sm font-medium border transition-all duration-150 cursor-pointer select-none
                            ${isSelected
                              ? 'bg-gray-900 text-white border-gray-900 shadow-sm'
                              : 'bg-white text-gray-600 border-gray-300 hover:border-gray-500 hover:text-gray-800'
                            }
                          `}
                        >
                          {isSelected && (
                            <span className="mr-1">✓</span>
                          )}
                          {cat.name}
                        </button>
                      );
                    })}
                  </div>
                )}
                {errors.categories && (
                  <p className="text-red-500 text-xs mt-1">{errors.categories}</p>
                )}
              </div>

              {/* Descripción */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  placeholder="Descripción del producto"
                />
              </div>

              {/* Selector de imágenes múltiples */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Imágenes
                  {imageUrls.length > 0 && (
                    <span className="ml-1 text-gray-400 font-normal text-xs">
                      ({imageUrls.length} imagen{imageUrls.length !== 1 ? 'es' : ''})
                    </span>
                  )}
                </label>
                <div className="flex gap-2">
                  <input
                    type="url"
                    value={newImageUrl}
                    onChange={(e) => setNewImageUrl(e.target.value)}
                    onKeyDown={handleImageUrlKeyDown}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                    placeholder="https://ejemplo.com/imagen.jpg"
                  />
                  <button
                    type="button"
                    onClick={addImageUrl}
                    disabled={!newImageUrl.trim()}
                    className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
                  >
                    +
                  </button>
                </div>
                {errors.duplicateImage && <p className="text-red-500 text-xs mt-1">{errors.duplicateImage}</p>}

                {imageUrls.length > 0 && (
                  <div className="mt-3 space-y-2">
                    {imageUrls.map((url, index) => (
                      <div key={index} className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2">
                        <span className="text-xs text-gray-400 font-mono w-5">{index + 1}</span>
                        {index === 0 && (
                          <span className="text-[10px] bg-gray-900 text-white px-1.5 py-0.5 rounded font-medium">Principal</span>
                        )}
                        <img
                          src={url}
                          alt={`img ${index + 1}`}
                          className="w-10 h-10 object-cover rounded"
                          onError={(e) => { e.target.style.display = 'none'; }}
                        />
                        <span className="flex-1 text-sm text-gray-600 truncate">{url}</span>
                        <button
                          type="button"
                          onClick={() => removeImageUrl(index)}
                          className="text-red-400 hover:text-red-600 text-sm font-bold px-1"
                        >
                          x
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Atributo 1 */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Atributo 1</label>
                <input
                  type="text"
                  name="atributo_1"
                  value={formData.atributo_1}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  placeholder="Valor del atributo 1"
                />
              </div>

              {/* Atributo 2 */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Atributo 2</label>
                <input
                  type="text"
                  name="atributo_2"
                  value={formData.atributo_2}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  placeholder="Valor del atributo 2"
                />
              </div>

              {/* Contador Inicial */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Contador Inicial</label>
                <input
                  type="number"
                  name="product_counter_init"
                  value={formData.product_counter_init}
                  onChange={handleChange}
                  min="0"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  placeholder="Valor inicial del contador"
                />
              </div>

              {/* Contador Actual */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Contador Actual</label>
                <input
                  type="number"
                  name="product_counter"
                  value={formData.product_counter}
                  onChange={handleChange}
                  min="0"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  placeholder="Valor actual del contador"
                />
              </div>

              {/* Aplica promociones */}
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="apply_promotions"
                  checked={formData.apply_promotions}
                  onChange={handleChange}
                  className="w-4 h-4 text-gray-600 border-gray-300 rounded focus:ring-gray-500"
                />
                <label className="ml-2 text-sm text-gray-700">Aplica promociones</label>
              </div>

              {/* Botones */}
              <div className="flex space-x-3 pt-4">
                <GrayButton onClick={handleClose} className="flex-1">Cancelar</GrayButton>
                <BlackButton type="submit" className="flex-1">Guardar Cambios</BlackButton>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalEditProduct;